import { render } from "./activity-index.vue?vue&type=template&id=12753da4"
import script from "./activity-index.vue?vue&type=script&lang=js"
export * from "./activity-index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__